// Obtener los elements del slider
const slider = document.getElementById('announcement-bar-announces');
const elements = slider.querySelectorAll('.announcement-bar');
const time = 3000;
let currentIndex = 0;

if (slider && elements && elements.length > 1) {
  function showNext() {
    // Ocultar el elemento actual
    elements[currentIndex].classList.remove('show');
  
    // Incrementar el índice del elemento actual y mostrar el siguiente
    currentIndex++;
    if (currentIndex >= elements.length) currentIndex = 0;
    elements[currentIndex].classList.add('show');
    setTimeout(showNext, time);
  }

  setTimeout(showNext, time);
}